'use client';

//* Styles
import ProductsIndividualTemplateStyle from './style';

//* Components
import Content from '../components/Content';
import Cooking from '../components/Cooking';
import Products from '../components/Products';
import CallToAction from '@/modules/_sections/CallToAction';
import FAQComp from '@/modules/_sections/FAQComp';

const ProductsIndividualTemplate = ({ pageData }) => {
	const { id, title, description, volume, link, images, composition, food_pairings, color, nosen, infos } = pageData;

	return (
		<ProductsIndividualTemplateStyle>
			<Content
				title={title}
				description={description}
				volume={volume}
				link={link}
				images={images}
				composition={composition}
				food_pairings={food_pairings}
				color={color}
				nosen={nosen}
				infos={infos}
			/>

			<Cooking id={id} />

			<Products id={id} />

			<FAQComp />

			<CallToAction />
		</ProductsIndividualTemplateStyle>
	);
};

export default ProductsIndividualTemplate;
